import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { ObjectResolverBase } from '../../shared/base/object-resolver-base';

import { Lecture } from './lecture';
import { LectureService } from './lecture.service';

@Injectable()
export class LectureResolver extends ObjectResolverBase<Lecture> {
  constructor(service: LectureService, router: Router) {
    super(service, router);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/shared/lecture-resolver.service.ts